import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import * as XLSX from 'xlsx';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/Tableproperty.css';
import { Button, FormCheck, Dropdown, DropdownButton } from 'react-bootstrap';
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { jsPDF } from "jspdf";
import 'bootstrap/dist/css/bootstrap.min.css';
import { UploadLoadingIcon } from "../components/Propertyfile";
import { Audittemplatelist, CharDate, NumberCols, Trend_report } from '../components/ApiProperty';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import { faSort, faSortUp, faSortDown, faListAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/gapsycaudit.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { useSession } from '../components/SessionContext';

import {
  Chart,
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
} from 'chart.js';


const GapsyTrendreport = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('outline'); // 'manual' or 'ai'
  const [filteredTables, setFilteredTables] = useState([]);
  const [selectedPrefix, setSelectedPrefix] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [tableNames, setTableNames] = useState([]);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [recordsPerPage1] = useState(7); // Set the number of records per page
  const [selectedName, setSelectedName] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const prefixes = Object.keys(tableNames);
  const [sheetSelectionModal, setSheetSelectionModal] = useState({
    show: false,
    sheets: [],
    selectedSheets: [],
    workbook: null,
    file: null,
  });
  const [columns, setColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [sumColumns, setSumColumns] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [availableSumColumns, setAvailableSumColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [originalResponseData, setOriginalResponseData] = useState([]);
  const [error, setError] = useState("");
  const [sums, setSums] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const username = localStorage.getItem('username');
  const userRole = localStorage.getItem('userRole');
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [tempSelectedTable, setTempSelectedTable] = useState('');
  const [numericColumns, setNumericColumns] = useState([]);
  const [selectedNumericColumns, setSelectedNumericColumns] = useState([]);
  const [viewMode, setViewMode] = useState('trend'); // 'table' or 'trend'
  const [monthLabel, setMonthLabel] = useState(null);
  const department = sessionStorage.getItem("dept");
  const { sessionId } = useSession();
  let csrfToken = sessionStorage.getItem("tokenizedSession");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const computedSums = calculateSums();
    setSums(computedSums);
  }, [tableData, sumColumns, searchQuery, fromDate, toDate]);

  const userId = localStorage.getItem("userid");

  const fetchData = async () => {
    try {

      // const config = { params: { checkerId: userId, dept: department } };

      const config =
      {
        headers:
        {
          'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: { dept: department, reportType: "live" }
      };

      const response = await axios.post(Audittemplatelist, {}, config);


      const message = "Nothing pending for Upload data";

      if (response.data?.tableList?.length) {
        // Categorize tables by prefix
        const categorizedTables = {};

        response.data.tableList.forEach((table) => {
          const [prefix, ...rest] = table.split('_');
          if (!categorizedTables[prefix]) {
            categorizedTables[prefix] = [];
          }
          categorizedTables[prefix].push(table);
        });

        setTableNames(categorizedTables);
      } else {
        // responseBKP(response, setTableNames, message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (selectedPrefix) {
      // Set the filtered tables based on selectedPrefix
      setFilteredTables(tableNames[selectedPrefix] || []);
    } else {
      setFilteredTables([]); // Clear when no prefix is selected
    }
  }, [selectedPrefix, tableNames]);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const paginate1 = (pageNumber) => {
    setCurrentPage1(pageNumber);
  };


  const toTitleCase = (str) => {
    return str
      .replace(/[_-]/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  };

  const handleselecttablechar = async (tempSelectedTable) => {
    try {
      const config = {
        headers: {
          'userId': localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: { tableName: tempSelectedTable }
      };

      const response = await axios.post(CharDate, {}, config);
      return response.data?.col_names || [];
    } catch (error) {
      console.error('Error fetching columns:', error);
      return [];
    }
  };

  const handleselecttablenum = async (tempSelectedTable) => {
    try {
      const config = {
        headers: {
          'userId': localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: { tableName: tempSelectedTable }
      };

      const response = await axios.post(NumberCols, {}, config);
      return response.data?.col_name || [];
    } catch (error) {
      console.error('Error fetching columns:', error);
      return [];
    }
  };

  const filteredRecords1 = useMemo(() => {
    if (!selectedPrefix) return [];

    const query = searchQuery.toLowerCase().trim();
    const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

    return filteredTablesForPrefix.filter((tableName) =>
      tableName.toLowerCase().includes(query)
    );
  }, [tableNames, searchQuery, selectedPrefix]);

  useEffect(() => {
    setCurrentPage1(1);
  }, [searchQuery]);

  useEffect(() => {
    setCurrentPage1(1);
  }, [selectedPrefix]);

  const sortedRecords1 = useMemo(() => {
    return [...filteredRecords1].sort((a, b) => {
      const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
      const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
      return bStarts - aStarts;
    });
  }, [filteredRecords1, searchQuery]);

  const indexOfLastRecord = currentPage1 * recordsPerPage1;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage1;
  const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord, indexOfLastRecord);

  const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);


  const handleSearchChange = (e) => {
    const input = e.target.value.trimStart(); // Remove leading spaces
    setSearchQuery(input);

    const pageNumber = parseInt(input, 10);

    // Check if input is a valid page number
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages1) {
      paginate1(pageNumber);
    }
  };
  const columnOrderMap = {
    reporting_date: 'Reporting Date',
    borrower_name: 'Borrower Name',
    customer_number: 'Customer Number',
    account_number: 'Account Number',
    asset_classification: 'Asset Classification',
    npa_amount: 'Npa Amount',
    specificprovision_amount: 'Specificprovision Amount'
  };



  const handleTableChange = (e) => {
    const selectedFullName = e.target.value;

    setTempSelectedTable(selectedFullName);

    const prefix = selectedFullName.split('_')[0];
    const suffix = selectedFullName.split('_').slice(1).join('_');

    setSelectedPrefix(prefix);
    setSelectedName(suffix); // Just store for future

    setColumns([]);
    setSelectedColumns([]);
    setNumericColumns([]);
    setSelectedNumericColumns([]);
    setTableColumns([]);
    setTableData([]);
    setOriginalResponseData([]);
  };


  const isAllSelected = (columns, tempSelectedColumns) =>
    columns.length > 0 && columns.every((col) => tempSelectedColumns.includes(col));

  const isPartiallySelected = (columns, tempSelectedColumns) =>
    columns.some((col) => tempSelectedColumns.includes(col)) &&
    !isAllSelected(columns, tempSelectedColumns);



  const generateReport = async () => {
    setLoading(true);
    const startTime = Date.now();

    setSelectedTable(tempSelectedTable);

    const tableName = tempSelectedTable;
    try {
      const config = {
        headers: {
          'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: {
          tableName: tableName,
          characterColumns: selectedColumns.join(","),
          numericColumns: selectedNumericColumns.join(",")
        }
      };

      const res = await axios.post(Trend_report, {}, config);
      const jsonData = Array.isArray(res.data) ? res.data : [];

      // Combine columns for transformation
      const allSelectedColumns = [...selectedColumns, ...selectedNumericColumns];

      // Transformation logic for both column types
      const finalColumns = allSelectedColumns.map(col => toTitleCase(col));
      const transformedData = jsonData.map(row => {
        const newRow = {};

        // Process both character and numeric columns
        allSelectedColumns.forEach(col => {
          if (row.hasOwnProperty(col)) {
            newRow[toTitleCase(col)] = row[col];
          }
        });

        return newRow;
      });

      setTableColumns(finalColumns);
      setTableData(transformedData);
      setOriginalResponseData(jsonData);
      // Render chart after data is set
      renderChart(jsonData);
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    } finally {
      const elapsed = Date.now() - startTime;
      const delay = 1000 - elapsed;
      if (delay > 0) {
        setTimeout(() => setLoading(false), delay);
      } else {
        setLoading(false);
      }
    }
  };




  const calculateSums = () => {
    const sums = {};

    // Convert fromDate and toDate strings to Date objects and only keep the date part
    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    if (fromDateObj) {
      fromDateObj.setHours(0, 0, 0, 0); // Start of the day
    }
    if (toDateObj) {
      toDateObj.setHours(23, 59, 59, 999); // End of the day
    }

    // Filter the table data based on the search query and date range
    const filteredData = tableData.filter(row => {
      // Filter by search query
      const matchesSearchQuery = !searchQuery || Object.values(row).some(value =>
        // value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        value != null && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );

      // Function to convert a string to Proper Case (PropCase)
      function toProperCase(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      // Normalize all keys to Proper Case
      const normalizedRow = Object.keys(row).reduce((acc, key) => {
        const properCaseKey = toProperCase(key);
        acc[properCaseKey] = row[key];
        return acc;
      }, {});

      // Try both possible keys for reporting date
      const reportingDateValue = row['reporting_date'] || row['Reporting Date'];
      const reportingDate = reportingDateValue ? new Date(reportingDateValue) : null;

      // Check for invalid date
      if (reportingDate && isNaN(reportingDate.getTime())) {
        console.error(`Invalid date: ${reportingDateValue}`);
        return false;
      }
      // Strip time from reportingDate for comparison
      if (reportingDate) {
        reportingDate.setHours(0, 0, 0, 0);
      }


      // Filter by date range
      const isWithinDateRange = (() => {
        if (fromDateObj && !toDateObj) {
          // Only fromDate is specified
          return reportingDate && reportingDate.getTime() === fromDateObj.getTime();
        }
        if (!fromDateObj && toDateObj) {
          // Only toDate is specified
          return reportingDate && reportingDate.getTime() === toDateObj.getTime();
        }
        if (fromDateObj && toDateObj) {
          // Both fromDate and toDate are specified
          return reportingDate && reportingDate >= fromDateObj && reportingDate <= toDateObj;
        }
        // No date filters are specified
        return true;
      })();

      return matchesSearchQuery && isWithinDateRange;
    });

    // Calculate sums for the selected numeric columns
    sumColumns.forEach((col) => {
      if (availableSumColumns.includes(col)) { // Ensure column is numeric
        const sum = filteredData.reduce((acc, row) => {
          const value = parseFloat(row[col]);
          return !isNaN(value) ? acc + value : acc;
        }, 0);
        sums[col] = sum;
      }
    });

    setFilteredData(filteredData); // Store the filtered data for display
    return sums;
  };

  const downloadXLSX = async () => {
    try {
      // 1. Ensure we have a valid table name
      const tableName = selectedTable ?
        selectedTable.replace(/_/g, ' ').toUpperCase() :
        'Report';

      // 2. Create workbook with validated sheet name
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(
        tableName.substring(0, 31) // Excel sheet name limit
      );

      // 3. Add Report Title at top
      const titleRow = worksheet.addRow([tableName]);
      titleRow.font = {
        size: 14,
        bold: true,
        color: { argb: 'FF366872' } // Your theme color
      };
      titleRow.alignment = { horizontal: 'center' };

      // Merge title cells across all columns
      if (tableColumns.length > 0) {
        worksheet.mergeCells(`A1:${String.fromCharCode(64 + tableColumns.length)}1`);
      }
      // Add spacing row
      worksheet.addRow([]);

      // Add headers with consistent styling
      const headerRow = worksheet.addRow(tableColumns);
      headerRow.font = {
        bold: true,
        color: { argb: 'FFFFFFFF' }, // White text
        size: 10 // Smaller header font
      };
      headerRow.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true
      };
      headerRow.height = 20; // Set header row height

      // Apply header styling to each cell
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF366872' } // Your theme color
        };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });

      // Add data rows with status column coloring
      filteredData.forEach((row, rowIndex) => {
        const dataRow = worksheet.addRow(tableColumns.map(col => {
          const cellValue = row[col];
          return (cellValue === '\N' || cellValue === '\\N' || cellValue === 'NULL') ? '' : cellValue;
        }));

        // Apply styling to each cell
        dataRow.eachCell((cell, colNumber) => {
          const columnName = tableColumns[colNumber - 1];

          // Base cell styling
          cell.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
          cell.font = {
            size: 9 // Smaller body font
          };

          // Status column coloring (matches PDF)
          if (columnName === 'Submitted Date' || columnName === 'Submitted By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFE6F7FF' } // Light blue
            };
            cell.font = {
              color: { argb: 'FF0056B3' }, // Dark blue text
              size: 9
            };
          } else if (columnName === 'Rejected Date' || columnName === 'Rejected By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFEBEE' } // Light red
            };
            cell.font = {
              color: { argb: 'FFC62828' }, // Dark red text
              size: 9
            };
          } else if (columnName === 'Modified Date' || columnName === 'Modified By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFF3E0' } // Light orange
            };
            cell.font = {
              color: { argb: 'FFE65100' }, // Dark orange text
              size: 9
            };
          } else if (columnName === 'Approved Date' || columnName === 'Approved By') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFE8F5E9' } // Light green
            };
            cell.font = {
              color: { argb: 'FF2E7D32' }, // Dark green text
              size: 9
            };
          } else if (rowIndex % 2 === 1) {
            // Alternate row coloring
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFF9F9F9' } // Light gray
            };
          }
        });
      });

      // Add sum row if needed
      if (sumColumns.length > 0) {
        const sumRow = tableColumns.map(col => (
          sumColumns.includes(col) && sums[col] !== undefined ? `Total: ${sums[col]}` : ""
        ));
        const sumRowAdded = worksheet.addRow(sumRow);
        sumRowAdded.font = { bold: true };
        sumRowAdded.eachCell(cell => {
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
        });
      }

      // Add footer information
      worksheet.addRow([]); // Spacer row

      const footerRow = worksheet.addRow(Array(tableColumns.length).fill(''));
      footerRow.getCell(1).value = `Prepared By: ${username}, ${userRole}`;
      footerRow.getCell(tableColumns.length).value =
        `Date: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;

      // Style footer
      footerRow.getCell(1).font = {
        size: 8,
        italic: true,
        color: { argb: 'FF366872' } // Theme color
      };
      footerRow.getCell(tableColumns.length).font = {
        size: 8,
        italic: true,
        color: { argb: 'FF366872' } // Theme color
      };
      footerRow.getCell(1).alignment = { horizontal: 'left' };
      footerRow.getCell(tableColumns.length).alignment = { horizontal: 'right' };

      // Auto-size columns with limits
      worksheet.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, cell => {
          const columnLength = cell.value ? cell.value.toString().length : 0;
          maxLength = Math.max(maxLength, columnLength);
        });
        column.width = Math.min(Math.max(maxLength + 2, 10), 30); // Min 10, Max 30
      });

      // Freeze header row
      worksheet.views = [
        { state: 'frozen', xSplit: 0, ySplit: 2 } // Freeze title and header rows
      ];

      // 4. Generate filename with table name first
      const date = new Date();
      const formattedDate = date.toISOString().slice(0, 10).replace(/-/g, '-'); // YYYY-MM-DD


      // Ensure table name is in filename before date
      const fileName = `${tableName.replace(/\s+/g, '_')}_${formattedDate}.xlsx`;

      // 5. Save the workbook
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }, 100);

    } catch (error) {
      console.error('Error generating XLSX:', error);
      alert('Error generating Excel file. Please try again.');
    }
  };

  const downloadPDF = () => {
    // Create PDF with custom width to fit all columns
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [500, 210] // Very wide page (500mm) to fit all columns
    });

    // Set smaller font sizes
    const headerFontSize = 10; // Reduced from 12
    const bodyFontSize = 8;   // Reduced from 10

    // Set table title styling with smaller font
    doc.setFontSize(10); // Smaller title font
    doc.setTextColor(54, 104, 114); // #366872
    doc.setFont('helvetica', 'bold');

    // Add table title (centered)
    const tableTitle = selectedTable
      ? selectedTable.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
      : 'Report';
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(tableTitle);
    doc.text(tableTitle, (pageWidth - textWidth) / 2, 10); // Moved up slightly

    // Prepare data for the table
    const pdfData = sortedData.map(row =>
      tableColumns.map(col => {
        const cellValue = row[col];
        return (cellValue === '\N' || cellValue === '\\N' || cellValue === 'NULL') ? '' : cellValue;
      })
    );

    // Column styles with reduced padding
    const columnStyles = {};
    tableColumns.forEach((col, index) => {
      columnStyles[index] = {
        cellWidth: 'auto', // Let autoTable calculate width
        minCellWidth: 15,  // Minimum width
        fontSize: bodyFontSize
      };

      // Status column colors
      if (col === 'Submitted Date' || col === 'Submitted By') {
        columnStyles[index].fillColor = [230, 247, 255];
        columnStyles[index].textColor = [0, 86, 179];
      } else if (col === 'Rejected Date' || col === 'Rejected By') {
        columnStyles[index].fillColor = [255, 235, 238];
        columnStyles[index].textColor = [198, 40, 40];
      } else if (col === 'Modified Date' || col === 'Modified By') {
        columnStyles[index].fillColor = [255, 243, 224];
        columnStyles[index].textColor = [230, 81, 0];
      } else if (col === 'Approved Date' || col === 'Approved By') {
        columnStyles[index].fillColor = [232, 245, 233];
        columnStyles[index].textColor = [46, 125, 50];
      }
    });

    // AutoTable configuration for compact display
    autoTable(doc, {
      head: [tableColumns],
      body: pdfData,
      startY: 15, // Start lower to accommodate title
      theme: 'grid',
      tableWidth: 'wrap',
      headStyles: {
        fillColor: [54, 104, 114],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: headerFontSize, // Smaller header font
        halign: 'center',
        cellPadding: 2 // Reduced padding
      },
      bodyStyles: {
        fontSize: bodyFontSize, // Smaller body font
        cellPadding: 1,         // Reduced padding
        overflow: 'linebreak',
        halign: 'center',
        valign: 'middle'
      },
      columnStyles: columnStyles,
      margin: { top: 5, left: 5, right: 5 }, // Reduced margins
      showHead: 'firstPage',
      horizontalPageBreak: false, // Disable horizontal pagination
      pageBreak: 'avoid',         // Try to keep on one page
      styles: {
        fontSize: bodyFontSize,   // Base font size
        cellPadding: 1,          // Compact cells
        overflow: 'linebreak'    // Handle long text
      },
      didDrawPage: function (data) {
        // Compact footer
        doc.setFontSize(6); // Very small footer font
        doc.setTextColor(100);
        const finalY = doc.lastAutoTable.finalY || doc.internal.pageSize.getHeight() - 10;
        doc.text(`Prepared By: ${username}, ${userRole}`, 10, finalY + 5);
        const dateStr = new Date().toLocaleString();
        doc.text(dateStr, pageWidth - doc.getTextWidth(dateStr) - 10, finalY + 5);
      }
    });

    // Generate filename
    const filename = `${selectedTable || 'Report'}_${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(filename);
  };

  // Handler for download button click
  const handleDownload = (format) => {
    if (format === 'xlsx') {
      downloadXLSX();
    } else if (format === 'pdf') {
      downloadPDF();
    }
  };





  //table sort start
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
    }
    return faSort;
  };

  // Sorting the data based on the selected column and direction
  const sortedData = [...filteredData].sort((a, b) => {
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    // Check if this is a date column (you might want to make this more robust)
    const isDateColumn = sortConfig.key.toLowerCase().includes('date');

    if (isDateColumn) {
      // Convert date strings to Date objects for comparison
      const dateA = new Date(aValue);
      const dateB = new Date(bValue);

      return sortConfig.direction === 'asc'
        ? dateA - dateB
        : dateB - dateA;
    }


    // Check if both values are numeric
    const isNumeric = !isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue));

    if (isNumeric) {
      // Numeric comparison
      return sortConfig.direction === 'asc'
        ? parseFloat(aValue) - parseFloat(bValue)
        : parseFloat(bValue) - parseFloat(aValue);
    } else {
      // Lexicographic comparison for strings
      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    }
  });


  const handleDashboard = () => {
    navigate("/gapsyCdashboard");
  };

  // bar chart code statred 

  Chart.register(
    BarController,
    BarElement,
    LineController,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
  );

  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [xAxisColumn, setXAxisColumn] = useState(null);
  const renderChart = (data) => {
    // Destroy previous chart instance if exists
    if (chartInstance.current) {
      chartInstance.current.destroy();
      chartInstance.current = null;
    }

    // Check if we have data and selected columns
    if (!data || data.length === 0 || !selectedColumns || selectedColumns.length === 0 ||
      !selectedNumericColumns || selectedNumericColumns.length === 0) {
      return;
    }

    // Get canvas context safely
    const ctx = chartRef.current?.getContext('2d');
    if (!ctx) return;

    // Clear the canvas
    ctx.clearRect(0, 0, chartRef.current.width, chartRef.current.height);

    // Determine X-axis column
    // Remove the local xAxisColumn declaration and use the state version
    const detectedXAxis = selectedColumns.find(col => {
      if (!col) return false;
      const lowerCol = col.toLowerCase?.() || '';
      return lowerCol.includes('date') ||
        lowerCol.includes('month') ||
        lowerCol.includes('year') ||
        lowerCol.includes('period');
    }) || (selectedColumns[0] || '');

    // Update state only if it's different
    if (detectedXAxis !== xAxisColumn) {
      setXAxisColumn(detectedXAxis);
    }

    // Prepare data structure
    const labels = [];
    const datasets = [];
    let sortedData = []; // Declare this at the top level

    // Group data by X-axis column if it's a date
    const isDateColumn = detectedXAxis && (detectedXAxis.toLowerCase?.() || '').includes('date');

    if (isDateColumn) {
      const monthData = {};

      data.forEach(item => {
        if (!item || !item[xAxisColumn]) return;

        const dateStr = item[xAxisColumn];
        if (!dateStr) return;

        try {
          const date = new Date(dateStr);
          if (isNaN(date.getTime())) return; // Skip invalid dates
          const monthYearKey = `${date.getFullYear()}-${date.getMonth()}`;
          const monthYearLabel = date.toLocaleString('default', { month: 'short' }) + ' ' + date.getFullYear();

          if (!monthData[monthYearKey]) {
            monthData[monthYearKey] = {
              label: monthYearLabel,
              values: {}
            };
            selectedNumericColumns.forEach(col => {
              monthData[monthYearKey].values[col] = 0;
            });
          }

          selectedNumericColumns.forEach(col => {
            const value = parseFloat(item[col]) || 0;
            monthData[monthYearKey].values[col] += value;
          });
        } catch (e) {
          console.error('Error parsing date:', dateStr, e);
        }
      });

      // Convert to array and sort by date
      sortedData = Object.values(monthData).sort((a, b) => {
        return new Date(a.label) - new Date(b.label);
      });

      labels.push(...sortedData.map(item => item.label));
    } else {
      // For non-date columns
      const groupedData = {};

      data.forEach(item => {
        if (!item || !item[xAxisColumn]) return;

        const xValue = item[xAxisColumn];
        if (!xValue) return;

        if (!groupedData[xValue]) {
          groupedData[xValue] = {
            label: xValue,
            values: {}
          };
          selectedNumericColumns.forEach(col => {
            groupedData[xValue].values[col] = 0;
          });
        }

        selectedNumericColumns.forEach(col => {
          if (!col) return;
          const value = parseFloat(item[col]) || 0;
          groupedData[xValue].values[col] += value;
        });
      });

      labels.push(...Object.keys(groupedData));
      sortedData = Object.values(groupedData); // For percentage calculation
    }

    // Create gradient function
    const createGradient = (ctx, chartArea, index) => {
      const gradientColors = [
        { start: '#07beb8', end: '#967aa1' },
        { start: '#f25c54', end: '#967aa1' },
        { start: '#133c55', end: '#967aa1' },
        { start: '#ffc43d', end: '#967aa1' },
        { start: '#9c5d9a', end: '#967aa1' }
      ];

      const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
      const colors = gradientColors[index % gradientColors.length];
      gradient.addColorStop(0, colors.start);
      gradient.addColorStop(1, colors.end);
      return gradient;
    };

    // Get chart area dimensions
    const chartArea = {
      top: 0,
      bottom: chartRef.current.height
    };

    // Add bar datasets
    selectedNumericColumns.forEach((column, index) => {
      datasets.push({
        label: formatColumnName(column),
        data: sortedData.map(item => item.values[column]),
        backgroundColor: createGradient(ctx, chartArea, index),
        borderColor: createGradient(ctx, chartArea, index),
        borderWidth: 1,
        type: 'bar', // Explicitly set type
        order: 1, // Ensure bars render first
        yAxisID: 'y' // Explicitly assign to primary y-axis
      });
    });

    // Calculate percentages if we have data
    if (sortedData.length > 0 && selectedNumericColumns.length > 0) {
      const firstMonthValue = sortedData[0].values[selectedNumericColumns[0]];
      const percentageData = sortedData.map(item => {
        const currentValue = item.values[selectedNumericColumns[0]];
        return firstMonthValue !== 0
          ? ((currentValue - firstMonthValue) / Math.abs(firstMonthValue)) * 100
          : 0;
      });

      // Add percentage line dataset
      datasets.push({
        label: 'Percentage',
        data: percentageData,
        type: 'line',
        yAxisID: 'y-percentage',
        borderColor: '#4285F4', // Google blue
        backgroundColor: 'transparent',
        borderWidth: 2,
        pointBackgroundColor: '#4285F4', // Same blue for points
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.3, // Slightly curved line
        fill: false
      });
    }

    // Create chart only once
    if (labels.length > 0 && datasets.length > 0) {
      chartInstance.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: datasets
        },
        options: getChartOptions(xAxisColumn, selectedNumericColumns, tempSelectedTable)
      });
    }
  };

  const handleMonthClick = (monthLabel) => {
    setMonthLabel(monthLabel);
    if (!originalResponseData || !monthLabel || !xAxisColumn) return;

    // Extract year and month from the label (format: "MMM YYYY")
    const [monthStr, yearStr] = monthLabel.split(' ');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthIndex = monthNames.findIndex(m => m === monthStr);
    const year = parseInt(yearStr);

    if (monthIndex === -1 || isNaN(year)) return;

    // Filter data for the selected month
    const filteredData = originalResponseData.filter(item => {
      if (!item || !item[xAxisColumn]) return false;

      const dateStr = item[xAxisColumn];
      if (!dateStr) return false;

      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return false;
        return date.getMonth() === monthIndex && date.getFullYear() === year;
      } catch (e) {
        console.error('Error parsing date:', dateStr, e);
        return false;
      }
    });

    // Update the vertical chart with filtered data
    if (filteredData.length > 0) {
      const charts = extractTopItems(filteredData, selectedColumns, selectedNumericColumns, monthLabel);
      if (charts.length > 0) {
        setTopItemsCharts(charts);
        setCurrentChartIndex(0);
      }
    }
  };

  // Dynamic chart options
  const getChartOptions = (xAxisLabel, yAxisColumns, tableName) => {
    return {
      // ... existing options ...
      onClick: (e, elements) => {
        if (elements.length > 0) {
          const clickedIndex = elements[0].index;
          const clickedLabel = chartInstance.current.data.labels[clickedIndex];
          handleMonthClick(clickedLabel);
        }
      },
      onHover: (e, elements) => {
        if (elements.length > 0) {
          e.native.target.style.cursor = 'pointer';
        } else {
          e.native.target.style.cursor = 'default';
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          left: 5,
          right: 5,
          top: 5,
          bottom: 5
        }
      },
      plugins: {
        legend: {
          display: false
        },
        title: {
          display: true,
          // text: `${tableName} Trend`,
          // text: formatColumnName(tableName) + ' Trend',
          text: formatColumnName(
  tableName.replace(/^Finance_/, '')
) + ' Trend',
          font: { size: 10 },
          color: 'black',
          padding: { bottom: 5 }
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              let label = context.dataset.label || '';
              if (label) label += ': ';
              const value = context.raw;
              // Different formatting for percentage vs currency
              if (context.dataset.yAxisID === 'y-percentage') {
                return label + value.toFixed(1) + '%';
              }
              return label + formatCurrency(value);
            }
          },
          bodyFont: { size: 8 },
          weight: 'bold',
          padding: 6
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          title: {
            // display: true,
            display: false,
            position: 'left', // Explicitly set to left
            // text: yAxisColumns.length > 1 ? 'Amount' : yAxisColumns[0],
            text: formatColumnName(yAxisColumns.length > 1 ? 'Amount' : yAxisColumns[0]),
            font: {
              size: 8,
              weight: 'bold',
            },
            color: 'black',

          },
          // ticks: {
          //   callback: formatCurrency,
          //   color: 'black',
          //   font: {
          //     size: 7,
          //     weight: 'normal',
          //   },
          //   maxRotation: 0,
          //   autoSkip: true
          // },
          ticks: {
  display: false
},
          grid: {
            display: true   // Remove grid lines for cleaner look
          }
        },
        'y-percentage': {
          position: 'right',
          beginAtZero: false, // Important for percentage changes
          title: {
            display: true,
            text: 'Percentage',
            font: {
              size: 8,
              weight: 'bold',
            },
            color: 'black',
          },
          ticks: {
            callback: (value) => value + '%',
            color: 'black',
            font: {
              size: 7,
              weight: 'normal',
            },
            maxRotation: 0,
            autoSkip: true
          },
          grid: {
            drawOnChartArea: false // only show grid for primary Y-axis
          },
          min: -100,
          max: 100,
        },
        x: {
          title: {
            display: true,
            // text: xAxisLabel,
            text: formatColumnName(xAxisLabel),
            font: {
              size: 8,
              weight: 'bold',
            },
            color: 'black',
          },
          ticks: {
            color: 'black',
            font: {
              size: 7,
              weight: 'normal',
            },
            maxRotation: 0,
            autoSkip: true
          },
          grid: {
            display: true  // Remove grid lines for cleaner look
          }
        }
      }
    };
  };

  // Helper function to format currency values
  const formatCurrency = (value) => {
    if (value >= 1000000) return `${Math.round(value / 1000000)}M`;
    if (value >= 1000) return `${Math.round(value / 1000)}k`;
    return `${value}`;
  };

  // Clean up chart instance on component unmount
  useEffect(() => {
    if (originalResponseData && originalResponseData.length > 0 && viewMode === 'trend') {
      // Validate columns first
      const validSelectedColumns = selectedColumns?.filter(col => col != null) || [];
      const validNumericColumns = selectedNumericColumns?.filter(col => col != null) || [];

      if (validSelectedColumns.length > 0 && validNumericColumns.length > 0) {
        renderChart(originalResponseData);
      }
    }
  }, [originalResponseData, selectedColumns, selectedNumericColumns, viewMode, xAxisColumn]);

  // bar chart code ended

  // vertical bar chart code statred 
  // Add these state variables at the top of your component
  const [topItemsCharts, setTopItemsCharts] = useState([]);
  const [currentChartIndex, setCurrentChartIndex] = useState(0);
  const topItemsChartRef = useRef(null);
  const topItemsChartInstance = useRef(null);

  // Extract top items data for each valid column
  const extractTopItems = (data, charColumns, numColumns, monthLabel = null) => {
    if (!data || data.length === 0) return [];

    // Filter out date and description columns from charColumns
    const validCharColumns = charColumns.filter(col => {
      const lowerCol = col.toLowerCase();
      return !['date', 'description', 'transactiondate', 'valuedate', 'asofdate', 'postingdate']
        .some(term => lowerCol.includes(term));
    });

    // Filter out non-numeric columns from numColumns (just in case)
    const validNumColumns = numColumns.filter(col => {
      // Check if the column contains numeric data (simple check)
      return data.some(row => !isNaN(parseFloat(row[col])));
    });

    const charts = [];

    validCharColumns.forEach(nameField => {
      validNumColumns.forEach(amountField => {
        // Skip if nameField and amountField are the same
        if (nameField === amountField) return;

        // Generate title
        const formattedName = formatColumnName(nameField);
        const formattedAmount = formatColumnName(amountField);
        // Format the month label to be more readable if needed
        const formattedMonthLabel = monthLabel
          ? monthLabel.replace(/([A-Za-z]+) (\d+)/, '$1 $2') // Example: "Jan2023" -> "Jan 2023"
          : '';

        const title = monthLabel
          ? `Top 5 ${formattedName} by ${formattedAmount} - ${formattedMonthLabel}`
          : `Top 5 ${formattedName} by ${formattedAmount}`;

        // Process data
        const itemsMap = {};
        data.forEach(row => {
          const name = row[nameField];
          const amount = parseFloat(row[amountField]) || 0;
          if (name && !isNaN(amount)) {
            itemsMap[name] = (itemsMap[name] || 0) + amount;
          }
        });

        const items = Object.entries(itemsMap)
          .map(([name, amount]) => ({ name, amount }))
          .sort((a, b) => b.amount - a.amount)
          .slice(0, 5);

        if (items.length > 0) {
          charts.push({
            items,
            title,
            amountField // Store which amount field was used
          });
        }
      });
    });

    return charts;
  };


  // Process data when input changes
  useEffect(() => {
    if (originalResponseData?.length > 0) {
      const charts = extractTopItems(originalResponseData, selectedColumns, selectedNumericColumns);
      setTopItemsCharts(charts);
      setCurrentChartIndex(0);
    } else {
      setTopItemsCharts([]);
    }
  }, [originalResponseData, selectedColumns, selectedNumericColumns]);

  // Render/update chart when data or index changes
  useEffect(() => {
    if (viewMode === 'trend' && topItemsCharts.length > 0 && topItemsChartRef.current) {
      renderTopItemsChart();
    }

    return () => {
      if (topItemsChartInstance.current) {
        topItemsChartInstance.current.destroy();
      }
    };
  }, [viewMode, topItemsCharts, currentChartIndex]);


  // Add this chart rendering function
  const renderTopItemsChart = () => {
    const ctx = topItemsChartRef.current.getContext('2d');
    const { items, title } = topItemsCharts[currentChartIndex];

    if (topItemsChartInstance.current) {
      topItemsChartInstance.current.destroy();
    }

    // Clear canvas
    ctx.clearRect(0, 0, topItemsChartRef.current.width, topItemsChartRef.current.height);

    // Gradient colors
    const gradientColors = [
      { start: '#07beb8', end: '#967aa1' }, // Purple to Teal
      { start: '#f25c54', end: '#967aa1' }, // Purple to Coral
      { start: '#133c55', end: '#967aa1' }, // Purple to Navy
      { start: '#ffc43d', end: '#967aa1' }, // Purple to Gold
      { start: '#9c5d9a', end: '#967aa1' }  // NEW: Purple to Muted Plum (5th color)
    ];

    const createGradient = (ctx, chartArea, index) => {
      const gradient = ctx.createLinearGradient(
        chartArea.left, 0,
        chartArea.right, 0
      );
      const colors = gradientColors[index % gradientColors.length];
      gradient.addColorStop(0, colors.start);
      gradient.addColorStop(1, colors.end);
      return gradient;
    };

    const chartArea = {
      left: 0,
      right: topItemsChartRef.current.width,
      top: 0,
      bottom: topItemsChartRef.current.height
    };


    const backgroundGradients = items.map((_, index) =>
      createGradient(ctx, chartArea, index)
    );

    topItemsChartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: items.map(item => item.name),
        datasets: [{
          label: 'Amount',
          data: items.map(item => item.amount),
          backgroundColor: backgroundGradients,
          borderColor: backgroundGradients,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
          }
        },
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            // text: title,
            text: formatColumnName(title),
            font: {
              
              size: 10,
              // weight: 'bold',
            },
            color: 'black',
            padding: {
              bottom: 5
            },
            align: 'center'
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const value = context.parsed.x;
                if (value >= 1000000) {
                  return `${Math.round(value / 1000000)}M`;
                } else if (value >= 1000) {
                  return `${Math.round(value / 1000)}k`;
                }
                return `${value}`;
              }
            },
            color: 'black',
            bodyFont: {
              size: 8,
              weight: 'normal',

            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Amount',
              color: 'black',
              font: {
                size: 8,
                weight: 'bold',
              }
            },
            ticks: {
              callback: (value) => {
                if (value >= 1000000) {
                  return `${Math.round(value / 1000000)}M`;
                } else if (value >= 1000) {
                  return `${Math.round(value / 1000)}k`;
                }
                return `${value}`;
              },
              font: {
                size: 7,
                weight: 'normal',
              },
              color: 'black',
            },
            grid: {
              display: true
            }
          },
          y: {
            ticks: {
              font: {
                size: 7,
                weight: 'normal',
              },
              color: 'black',
            },
            grid: {
              display: true
            }
          }
        }
      }
    });
  };
  // vertical bar chart code ended

  // Total accounts started
  const calculateColumnCounts = (data, columns) => {
    if (!data || !columns || columns.length === 0) return {};

    const counts = {};
    columns.forEach(col => {
      const uniqueValues = new Set(data.map(row => row[col]));
      counts[col] = uniqueValues.size;
    });
    return counts;
  };
  const columnCounts = useMemo(() => {
    return calculateColumnCounts(originalResponseData, selectedColumns);
  }, [originalResponseData, selectedColumns]);

  // first column sum amount display
  const calculateFirstColumnSum = (data, numericColumns) => {
    if (!data?.length || !numericColumns?.length) return { sum: 0, columnName: '' };

    const firstColumn = numericColumns[0];
    const sum = data.reduce((total, row) => {
      // Handle both string numbers ("1,000") and regular numbers
      const value = typeof row[firstColumn] === 'string'
        ? parseFloat(row[firstColumn].replace(/,/g, ''))
        : parseFloat(row[firstColumn]);
      return total + (isNaN(value) ? 0 : value);
    }, 0);

    return { sum, columnName: firstColumn };
  };

  const [firstColumnSum, setFirstColumnSum] = useState({ sum: 0, columnName: '' });

  useEffect(() => {
    if (originalResponseData && selectedNumericColumns?.length > 0) {
      const result = calculateFirstColumnSum(originalResponseData, selectedNumericColumns);
      setFirstColumnSum(result);
    } else {
      setFirstColumnSum({ sum: 0, columnName: '' });
    }
  }, [originalResponseData, selectedNumericColumns]);

  // second column sum amount display
  const calculateSecondColumnSum = (data, numericColumns) => {
    if (!data?.length || !numericColumns?.length || numericColumns.length < 2)
      return { sum: 0, columnName: '' };

    const secondColumn = numericColumns[1];
    const sum = data.reduce((total, row) => {
      const value = typeof row[secondColumn] === 'string'
        ? parseFloat(row[secondColumn].replace(/,/g, ''))
        : parseFloat(row[secondColumn]);
      return total + (isNaN(value) ? 0 : value);
    }, 0);

    return { sum, columnName: secondColumn };
  };

  const [secondColumnSum, setSecondColumnSum] = useState({ sum: 0, columnName: '' });

  useEffect(() => {
    if (originalResponseData && selectedNumericColumns?.length > 0) {
      // First column sum (existing)
      const firstResult = calculateFirstColumnSum(originalResponseData, selectedNumericColumns);
      setFirstColumnSum(firstResult);

      // Second column sum (new)
      const secondResult = calculateSecondColumnSum(originalResponseData, selectedNumericColumns);
      setSecondColumnSum(secondResult);
    } else {
      setFirstColumnSum({ sum: 0, columnName: '' });
      setSecondColumnSum({ sum: 0, columnName: '' });
    }
  }, [originalResponseData, selectedNumericColumns]);


  const formatColumnName = (columnName) => {
    if (!columnName) return '';

    // Replace underscores with spaces
    const withSpaces = columnName.replace(/_/g, ' ');

    // Convert to title case
    return withSpaces.replace(/\w\S*/g, (word) =>
      word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
    );
  };

  return (
    <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
      <Header />
      <Navigation />
      <div className="top-0 px-4 py-2 text-white">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-1">
                <li className="breadcrumb-item">
                  <a className={`text-info ${styles.textInfo}`} onClick={handleDashboard} style={{ textDecoration: 'none' }}>
                    <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                  </a>
                </li>
                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                  {/* <i className="bi bi-file-richtext me-2"></i> Trend Analysis Report */}
                  <i className="bi bi-graph-up me-2"></i> Trend Analysis Report
                </li>
              </ol>
            </nav>
          </div>

        </div>
      </div>
      <main className="flex-grow-1 container-fluid">
        <div className={styles.mainContainer}>
          <div className="container-fluid">
            <div className="row">
              {/* left side Column code */}
              <div className="col-lg-3 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">
                    <form className="w-100">
                      {/* Custom Tab Navigation */}
                      <div className={tabStyles.tabContainer}>
                        <div
                          className={`${tabStyles.tab} ${activeTab === 'outline' ? tabStyles.activeTab : ''}`}
                          onClick={() => {
                            setActiveTab('outline');
                            setSearchQuery('');
                            setFromDate('');
                            setToDate('');
                          }}
                        >
                          <FontAwesomeIcon icon={faListAlt} className="me-1" />
                          Outline
                        </div>
                        <div
                          className={`${tabStyles.tab} ${activeTab === 'filters' ? tabStyles.activeTab : ''}`}
                          onClick={() => {
                            setActiveTab('filters');
                            setSearchQuery('');
                            setFromDate('');
                            setToDate('');
                          }}
                        >
                          <FontAwesomeIcon icon={faFilter} className="me-1" />
                          Filters
                        </div>
                      </div>


                      {/* Tab Content */}
                      {activeTab === 'outline' && (
                        <div className="row mb-2 p-2">
                          {/* Table select dropdown */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              Department
                            </label>
                            <div>
                              <DepartmentDropdown
                                selectedPrefix={selectedPrefix}
                                setSelectedPrefix={(prefix) => {
                                  setSelectedPrefix(prefix);          // update selected prefix
                                  setTempSelectedTable('');           // clear selected table
                                  setSelectedColumns([]);             // clear selected columns
                                  setColumns([]);                     // clear available columns
                                  setTableData([]);                   // clear table data
                                  setTableColumns([]);                // clear table column titles
                                  setNumericColumns([]);
                                  setSelectedNumericColumns([]);
                                }}
                                prefixes={prefixes}
                              />

                            </div>
                          </div>
                          <div className="col-12 mb-2">
                            <label htmlFor="checkerUser" className="form-label text-black mb-2">
                              Table Selection
                            </label>

                            <div className="table-on-homepage-only">
                              <div className="dropdown position-relative">
                                <button
                                  className="btn btn-light btn-sm dropdown-toggle text-truncate d-flex justify-content-between align-items-center"
                                  type="button"
                                  id="tableDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    width: '100%',            // Full width
                                    minWidth: '200px',        // Optional: match select width
                                    textAlign: 'left',        // Ensures text starts from left
                                    paddingRight: '1.5rem'    // Space for dropdown arrow
                                  }}
                                  disabled={!selectedPrefix}
                                >
                                  <span className="text-truncate">
                                    {tempSelectedTable
                                      ? toTitleCase(tempSelectedTable.split('_').slice(1).join('_'))
                                      : "Select Table"}
                                  </span>
                                  <i className="ms-auto dropdown-toggle-icon"></i> {/* Optional arrow spacing control */}
                                </button>

                                <ul
                                  className={`dropdown-menu mt-1 w-100 ${styles.dropdownMenu}`}
                                  aria-labelledby="tableDropdown"
                                >
                                  {sortedRecords1.map((tableName, idx) => {
                                    const suffix = tableName.split('_').slice(1).join('_');
                                    const displayName = toTitleCase(suffix);
                                    return (
                                      <li key={idx}>
                                        <a
                                          className={`dropdown-item small ${styles.dropdownItem}`}
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleTableChange({ target: { value: tableName } });
                                          }}
                                        >
                                          {displayName}
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>


                          </div>

                          {/* Columns dropdown */}
                          <div className='col-12 mb-2'>
                            <div className="table-on-homepage-only mb-1">
                              <label htmlFor="checkerUser" className="form-label text-black mb-1">
                                Category Column Selection
                              </label>
                              <div className="dropdown position-relative">
                                <button
                                  className="btn btn-light btn-sm dropdown-toggle text-truncate d-flex justify-content-between align-items-center"
                                  type="button"
                                  id="columnsDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    width: '100%',
                                    minWidth: '200px',
                                    textAlign: 'left',
                                    paddingRight: '1.5rem'
                                  }}
                                  disabled={!tempSelectedTable}
                                  onClick={async () => {
                                    if (tempSelectedTable && columns.length === 0) {
                                      const cols = await handleselecttablechar(tempSelectedTable);

                                      const ordered = Object.keys(columnOrderMap).filter(col => cols.includes(col));
                                      const extra = cols.filter(col => !ordered.includes(col));
                                      const final = [...ordered, ...extra];

                                      setColumns(final);
                                      setAvailableSumColumns(final);
                                    }
                                  }}
                                >
                                  <span className="text-truncate small">
                                    {selectedColumns.length > 0
                                      ? `${selectedColumns.length} Column${selectedColumns.length > 1 ? 's' : ''} Selected`
                                      : "Select Columns"}
                                  </span>

                                  <i className="ms-auto dropdown-toggle-icon"></i>
                                </button>

                                <ul
                                  className={`dropdown-menu mt-1 w-100 ${styles.dropdownMenu}`}
                                  aria-labelledby="columnsDropdown"
                                  style={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    fontSize: '12px',
                                    paddingBottom: '5px',
                                    paddingTop: '5px'
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >

                                  {columns.length === 0 ? (
                                    <li className="dropdown-item disabled">No Columns Found</li>
                                  ) : (
                                    <>
                                      <li className="dropdown-item px-3 py-1">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="selectAllColumns"
                                            checked={selectedColumns.length === columns.length}
                                            onChange={(e) => {
                                              const checked = e.target.checked;
                                              if (checked) {
                                                setSelectedColumns([...columns]);
                                                setTimeout(() => document.body.click(), 100); // close dropdown
                                              } else {
                                                setSelectedColumns([]);
                                              }
                                            }}
                                          />
                                          <label className="form-check-label" htmlFor="selectAllColumns">
                                            Select All Columns
                                          </label>
                                        </div>
                                      </li>

                                      <li><hr className="dropdown-divider" /></li>

                                      {columns.map((col, idx) => (
                                        <li key={idx} className="dropdown-item px-3 py-1 text-truncate" title={col}>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`col-${idx}`}
                                              checked={selectedColumns.includes(col)}
                                              onChange={(e) => {
                                                const updated = e.target.checked
                                                  ? [...selectedColumns, col]
                                                  : selectedColumns.filter(c => c !== col);
                                                setSelectedColumns(updated);

                                                if (updated.length === columns.length) {
                                                  setTimeout(() => document.body.click(), 100);
                                                }
                                              }}
                                            />
                                            <label className="form-check-label text-truncate" htmlFor={`col-${idx}`}>
                                              {toTitleCase(col)}
                                            </label>
                                          </div>
                                        </li>
                                      ))}
                                    </>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>


                          <div className='col-12 mb-2'>
                            <div className="table-on-homepage-only mb-1">
                              <label htmlFor="checkerUser" className="form-label text-black mb-1">
                                Measurement Column Selection
                              </label>
                              <div className="dropdown position-relative">
                                <button
                                  className="btn btn-light btn-sm dropdown-toggle text-truncate d-flex justify-content-between align-items-center"
                                  type="button"
                                  id="numericColumnsDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  style={{
                                    width: '100%',
                                    minWidth: '200px',
                                    textAlign: 'left',
                                    paddingRight: '1.5rem'
                                  }}
                                  disabled={!tempSelectedTable}
                                  onClick={async () => {
                                    if (tempSelectedTable && numericColumns.length === 0) {
                                      const cols = await handleselecttablenum(tempSelectedTable);

                                      const ordered = Object.keys(columnOrderMap).filter(col => cols.includes(col));
                                      const extra = cols.filter(col => !ordered.includes(col));
                                      const final = [...ordered, ...extra];

                                      setNumericColumns(final);
                                    }
                                  }}
                                >
                                  <span className="text-truncate small">
                                    {selectedNumericColumns.length > 0
                                      ? `${selectedNumericColumns.length} Column${selectedNumericColumns.length > 1 ? 's' : ''} Selected`
                                      : "Select Columns"}
                                  </span>
                                  <i className="ms-auto dropdown-toggle-icon"></i>
                                </button>

                                <ul
                                  className={`dropdown-menu mt-1 w-100 ${styles.dropdownMenu}`}
                                  aria-labelledby="numericColumnsDropdown"
                                  style={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    fontSize: '12px',
                                    paddingBottom: '5px',
                                    paddingTop: '5px'
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {numericColumns.length === 0 ? (
                                    <li className="dropdown-item disabled">No Columns Found</li>
                                  ) : (
                                    <>
                                      <li className="dropdown-item px-3 py-1">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="selectAllNumericColumns"
                                            checked={selectedNumericColumns.length === numericColumns.length}
                                            onChange={(e) => {
                                              const checked = e.target.checked;
                                              if (checked) {
                                                setSelectedNumericColumns([...numericColumns]);
                                                setTimeout(() => document.body.click(), 100);
                                              } else {
                                                setSelectedNumericColumns([]);
                                              }
                                            }}
                                          />
                                          <label className="form-check-label" htmlFor="selectAllNumericColumns">
                                            Select All Columns
                                          </label>
                                        </div>
                                      </li>

                                      <li><hr className="dropdown-divider" /></li>

                                      {numericColumns.map((col, idx) => (
                                        <li key={idx} className="dropdown-item px-3 py-1 text-truncate" title={col}>
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`num-col-${idx}`}
                                              checked={selectedNumericColumns.includes(col)}
                                              onChange={(e) => {
                                                const updated = e.target.checked
                                                  ? [...selectedNumericColumns, col]
                                                  : selectedNumericColumns.filter(c => c !== col);
                                                setSelectedNumericColumns(updated);

                                                if (updated.length === numericColumns.length) {
                                                  setTimeout(() => document.body.click(), 100);
                                                }
                                              }}
                                            />
                                            <label className="form-check-label text-truncate" htmlFor={`num-col-${idx}`}>
                                              {toTitleCase(col)}
                                            </label>
                                          </div>
                                        </li>
                                      ))}
                                    </>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>


                          {/* Generate Report button */}
                          <div className="col-12 mb-2">
                            <Button
                              variant="primary"
                              onClick={generateReport}
                              className="btn btn-sm border-0"
                              style={{ backgroundColor: '#366872', color: 'white' }}
                              disabled={selectedColumns.length === 0}
                            >
                              Generate Report
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* {loading && (
                        <div className="loading-overlay">
                          <UploadLoadingIcon />
                        </div>
                      )} */}

                      {activeTab === 'filters' && (
                        <div className="row mb-2 p-2">
                          {/* From Date */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              From Date
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              id="fromDate"
                              value={fromDate}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setFromDate("");
                                  setFilteredData(tableData);
                                } else {
                                  const formattedDate = formatDate(value);
                                  setFromDate(formattedDate);
                                }
                              }}
                            />
                          </div>

                          {/* To Date */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              To Date
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              id="toDate"
                              value={toDate}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setToDate("");
                                  setFilteredData(tableData);
                                } else {
                                  const formattedDate = formatDate(value);
                                  setToDate(formattedDate);
                                }
                              }}
                            />
                          </div>

                          {/* Search */}
                          <div className="col-12 mb-2">
                            <label htmlFor="department" className="form-label text-black mb-2">
                              Search
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              id="search"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}

                            />
                          </div>

                          {/* Download button */}
                          <div className="col-12 mb-3">
                            <DropdownButton
                              id="dropdown-custom-download"
                              title="Download"
                              variant="success"
                              className="w-100"
                              style={{ fontSize: '13px' }}
                            >
                              <Dropdown.Item style={{ fontSize: '12px' }} onClick={() => handleDownload('xlsx')}>XLSX</Dropdown.Item>
                              <Dropdown.Item style={{ fontSize: '12px' }} onClick={() => handleDownload('pdf')}>PDF</Dropdown.Item>
                            </DropdownButton>
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
              {/* right Column with Table */}
              <div className="col-lg-9 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body d-flex flex-column">
                    <div className="mb-1 position-relative"> {/* Changed to position-relative */}
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className={`pb-1 mb-0 flex-grow-1 ${styles.borderBottom}`}> {/* Added flex-grow-1 */}
                          Trend Analysis: {selectedName && selectedName.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                        </h6>
                        {tableData.length > 0 && (
                          <div className="ms-2" style={{
                            position: 'absolute',
                            right: 0,
                            top: '-10px' /* Adjust this to vertically align with your text */
                          }}>
                            {viewMode === 'trend' ? (
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => setViewMode('table')}
                                style={{ backgroundColor: '#366872', borderColor: '#366872' }}
                                title="Show Table"
                              >
                                <i className="bi bi-table"></i>
                              </button>
                            ) : (
                              <button
                                className="btn btn-sm btn-secondary"
                                onClick={() => setViewMode('trend')}
                                title="Show Trend Analysis"
                              >
                                <i className="bi bi-bar-chart-line"></i>
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div className="flex-grow-1" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                      <div className='custom-table-with-status-colors w-100'> */}
                    <div className="row">
                      <div className="col">

                        {viewMode === 'table' ? (
                          <div className="table-on-homepage-only">

                            <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                              {loading && (
                                <div className="table-loading-overlay d-flex justify-content-center align-items-center">
                                  <UploadLoadingIcon />
                                </div>
                              )}
                              <div className="custom-table-with-status-colors w-100 position-relative">
                                <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                  <thead className="sticky-header">
                                    <tr>
                                      {tableColumns.map((col, colIndex) => (
                                        <th
                                          key={colIndex}
                                          style={{
                                            textAlign: 'center',
                                            border: '1px solid black',
                                            padding: '5px',
                                            whiteSpace: 'nowrap',
                                            cursor: 'pointer',
                                            minWidth: '100px'
                                          }}
                                          onClick={() => requestSort(col)}
                                        >
                                          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            {col} <FontAwesomeIcon icon={getSortIcon(col)} style={{ marginLeft: '5px' }} />
                                          </span>
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody style={{ border: '1px solid #ddd', fontSize: '12px' }}>
                                    {sortedData.length > 0 ? (
                                      sortedData.map((row, rowIndex) => (
                                        <tr
                                          key={rowIndex}
                                          style={{
                                            border: '1px solid #ddd',
                                            backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#ffffff'
                                          }}
                                        >
                                          {tableColumns.map((col, colIndex) => {
                                            const getStatusClass = () => {
                                              if (col === 'Submitted Date' || col === 'Submitted By') {
                                                return 'submitted-status';
                                              }
                                              if (col === 'Rejected Date' || col === 'Rejected By') {
                                                return 'rejected-status';
                                              }
                                              if (col === 'Modified Date' || col === 'Modified By') {
                                                return 'modified-status';
                                              }
                                              if (col === 'Approved Date' || col === 'Approved By') {
                                                return 'approved-status';
                                              }
                                              return '';
                                            };

                                            const cellValue = row[col];
                                            const displayValue = (cellValue === '\N' || cellValue === '\\N' || cellValue === 'NULL')
                                              ? ''
                                              : cellValue;

                                            return (
                                              <td
                                                key={colIndex}
                                                className={getStatusClass()}
                                                style={{
                                                  border: '1px solid #ddd',
                                                  padding: '5px',
                                                  fontSize: '12px',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  whiteSpace: 'nowrap'
                                                }}
                                              >
                                                {displayValue}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      ))
                                    ) : (
                                      // <tr>
                                      //   <td colSpan={tableColumns.length} className="text-center py-3">
                                      //     No data available
                                      //   </td>
                                      // </tr>
                                      <tr>
                                        <td colSpan={tableColumns.length || 1} className="text-center py-3 text-muted">
                                          {!selectedPrefix
                                            ? "Select a Department"
                                            : !tempSelectedTable
                                              ? "Select a Tablename"
                                              : selectedColumns.length === 0
                                                ? "Select Columns and Proceed Generate Report"
                                                : "No data found for the selected criteria."}
                                        </td>
                                      </tr>

                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (

                          <div className="trend-analysis-container">
                            <div className={`${tableStyles.customScrollTable} p-2`} style={{
                              backgroundColor: 'transparent',
                              minHeight: '130px',
                              border: 'none'
                            }}>
                              {tableData.length > 0 ? (
                                <div className="trend-dashboard h-100">
                                  {/* Top Row - 70% Chart + 30% Stacked Cards */}
                                  <div className="row g-2 mb-2" style={{ height: '270px' }}>
                                    {/* Main Chart - 70% width */}
                                    <div className="col-md-8 h-100">
                                      <div className="rounded border border-dark p-1 h-100 d-flex flex-column">
                                        {/* Add the reset button at the top of the chart container */}
                                        {originalResponseData && originalResponseData.length > 0 && viewMode === 'trend' && (
                                          <div className="d-flex justify-content-end mb-1">
                                            <button
                                              onClick={() => {
                                                const charts = extractTopItems(originalResponseData, selectedColumns, selectedNumericColumns);
                                                setTopItemsCharts(charts);
                                                setCurrentChartIndex(0);
                                              }}
                                              className="btn btn-sm btn-outline-secondary"
                                              style={{
                                                padding: '2px 6px',
                                                fontSize: '10px',
                                                lineHeight: '1.2'
                                              }}
                                            >
                                              <i className="bi bi-arrow-counterclockwise me-1"></i> Reset
                                            </button>
                                          </div>
                                        )}

                                        {/* Chart container with calculated height */}
                                        <div className="flex-grow-1 position-relative" style={{ height: 'calc(100% - 30px)' }}>
                                          <canvas
                                            ref={chartRef}
                                            style={{ height: '100%', width: '100%' }}
                                          />
                                          {(!originalResponseData || originalResponseData.length === 0) && (
                                            <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                                              <i className="bi bi-bar-chart-line fs-3 me-2"></i>
                                              <span>No data available for chart</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* Right Side Cards - 30% width (stacked vertically) */}
                                    <div className="col-md-4 h-100">
                                      <div className="rounded border border-dark p-2 h-100 d-flex flex-column position-relative">
                                        {/* Left Arrow - Top Left Corner */}
                                        {topItemsCharts.length > 1 && (
                                          <button
                                            className="btn btn-sm btn-outline-secondary p-0 position-absolute d-flex align-items-center justify-content-center"
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              left: '8px',
                                              top: '8px',
                                              zIndex: 1
                                            }}
                                            onClick={() => setCurrentChartIndex(i => Math.max(0, i - 1))}
                                            disabled={currentChartIndex === 0}
                                          >
                                            <i className="bi bi-chevron-left" style={{ fontSize: '0.65rem' }}></i>
                                          </button>
                                        )}

                                        {loading && (
                                          <div className="table-loading-overlay d-flex justify-content-center align-items-center">
                                            <UploadLoadingIcon />
                                          </div>
                                        )}
                                        {/* Right Arrow - Top Right Corner */}
                                        {topItemsCharts.length > 1 && (
                                          <button
                                            className="btn btn-sm btn-outline-secondary p-0 position-absolute d-flex align-items-center justify-content-center"
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              right: '8px',
                                              top: '8px',
                                              zIndex: 1
                                            }}
                                            onClick={() => setCurrentChartIndex(i => Math.min(topItemsCharts.length - 1, i + 1))}
                                            disabled={currentChartIndex === topItemsCharts.length - 1}
                                          >
                                            <i className="bi bi-chevron-right" style={{ fontSize: '0.65rem' }}></i>
                                          </button>
                                        )}

                                        {/* Chart Position Indicator - Centered Below Title */}
                                        {topItemsCharts.length > 1 && (
                                          <div className="text-center mb-1">
                                            <small className="text-muted" style={{ fontSize: '0.6rem' }}>
                                              {currentChartIndex + 1} of {topItemsCharts.length}
                                            </small>
                                          </div>
                                        )}

                                        {/* Chart Area */}
                                        <div className="flex-grow-1">
                                          {topItemsCharts.length > 0 ? (
                                            <canvas ref={topItemsChartRef} />
                                          ) : (
                                            <div className="h-100 d-flex flex-column justify-content-center align-items-center text-muted">
                                              <i className="bi bi-bar-chart fs-3 me-2"></i>
                                              <span>No valid data available</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Bottom Row - 70% width for first two cards, 30% for third card */}
                                  <div className="row g-2 mt-2" style={{ height: '60px' }}>
                                    {/* First two cards (70% width) */}
                                    <div className="col-md-8 h-100">
                                      <div className="d-flex h-100" style={{ gap: '8px' }}>
                                        {/* Card 1: Total accounts */}
                                        <div className="rounded border border-dark p-1 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
                                          <div className="text-center">
                                            <div className="text-dark small" style={{ fontSize: '10px', marginBottom: '2px' }}>
                                              Total Records
                                            </div>
                                            <div className="text-primary fw-bold" style={{ fontSize: '1.1rem' }}>
                                              {originalResponseData?.length || 0}
                                            </div>
                                          </div>
                                        </div>

                                        {/* Card 2: Average NPA */}
                                        <div className="rounded border border-dark p-1 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
                                          <div className="text-center">
                                            <div className="text-dark small" style={{ fontSize: '10px', marginBottom: '2px' }}>
                                              {firstColumnSum.columnName ? `Total ${formatColumnName(firstColumnSum.columnName)}` : 'Total Amount'}
                                            </div>
                                            <div className="text-primary fw-bold" style={{ fontSize: '1.1rem' }}>
                                              {Math.abs(firstColumnSum.sum) >= 1000 ? (
                                                `${(firstColumnSum.sum / 1000).toLocaleString('en-IN', {
                                                  minimumFractionDigits: 1,
                                                  maximumFractionDigits: 1
                                                })}K`
                                              ) : (
                                                `${firstColumnSum.sum.toLocaleString('en-IN', {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2
                                                })}`
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Third card (30% width) */}
                                    <div className="col-md-4 h-100">
                                      {/* Card 3: Top NPA */}
                                      <div className="rounded border border-dark p-1 h-100 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
                                        <div className="text-center">
                                          <div className="text-dark small" style={{ fontSize: '10px', marginBottom: '2px' }}>
                                            {secondColumnSum.columnName ? `Total ${formatColumnName(secondColumnSum.columnName)}` : 'Total Amount'}
                                          </div>
                                          <div className={`fw-bold ${secondColumnSum.sum < 0 ? 'text-primary' : 'text-primary'}`} style={{ fontSize: '1.1rem' }}>
                                            {Math.abs(secondColumnSum.sum) >= 1000 ? (
                                              `${(secondColumnSum.sum / 1000).toLocaleString('en-IN', {
                                                minimumFractionDigits: 1,
                                                maximumFractionDigits: 1
                                              })}K`
                                            ) : (
                                              `${secondColumnSum.sum.toLocaleString('en-IN', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                              })}`
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="d-flex justify-content-center align-items-center">
                                  <div className="text-center text-muted">
                                    <i className="bi bi-bar-chart fs-1 mb-2"></i>
                                    <p>Select table and generate report to view trends</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {tableData.length > 0 && viewMode === 'table' && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '7px' }}>
                        <div className="text-start" style={{ fontSize: '12px' }}>
                          Total Records: {sortedData.length}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </main >
      <Footer />
    </div >
  );

}

export default GapsyTrendreport;
